<button class="circle-icon-btn" (click)="onClick($event)" [disabled]="disabled">
  <div class="circle-icon-btn-container" [ngClass]="getButtonClasses()">
    <i
      class="material-symbols-outlined"
      [@rotatedState]="{ value: getCurrentState, params: { initialDeg: initialDegrees, finalDeg: finalDegrees } }"
      >{{ icon }}</i
    >
  </div>
</button>
